import CombinationFormService from '@/components/question/forms/combination/CombinationFormService';
import FillInTheBlankFormService from '@/components/question/forms/fill-in-the-blank/FillInTheBlankFormService';
import MultimediaFormService from '@/components/question/forms/multimedia/MultimediaFormService';
import OrderingFormService from '@/components/question/forms/ordering/OrderingFormService';
import QuizFormService from '@/components/question/forms/quiz/QuizFormService';
import WritingFormService from '@/components/question/forms/writing/WritingFormService';
import FlashcardFormService from '@/components/question/forms/flashcard/FlashcardFormService';
import Activity from '@/models/Activity';
import {
  DNDOrdenationQuestion,
  DNDPositionalQuestion,
  FillInTheBlankQuestion,
  FlashcardQuestion,
  Question,
  QuestionTypeEnum,
  QuizQuestion,
  TextQuestion,
  TrueOrFalseQuestion,
  WritingQuestion,
} from '@/models/Question';
import TrueOrFalseFormService from '../forms/true-or-false/TrueOrFalseFormService';
import QuestionPlaceholder from './QuestionPlaceholder';

type QuestionFormFactoryProps = {
  activity: Activity;
  question: Question;
  isActive?: boolean;
};

export default function QuestionFormFactory({
  question,
  ...props
}: QuestionFormFactoryProps) {
  switch (question.type) {
    case QuestionTypeEnum.QUIZ:
      return <QuizFormService question={question as QuizQuestion} {...props} />;
    case QuestionTypeEnum.DND_ORDENATION:
      return (
        <OrderingFormService
          question={question as DNDOrdenationQuestion}
          {...props}
        />
      );
    case QuestionTypeEnum.DND_POSITIONAL:
      return (
        <CombinationFormService
          question={question as DNDPositionalQuestion}
          {...props}
        />
      );
    case QuestionTypeEnum.TRUE_OR_FALSE:
      return (
        <TrueOrFalseFormService
          question={question as TrueOrFalseQuestion}
          {...props}
        />
      );
    case QuestionTypeEnum.WRITING:
      return (
        <WritingFormService question={question as WritingQuestion} {...props} />
      );
    case QuestionTypeEnum.TEXT:
      return (
        <MultimediaFormService question={question as TextQuestion} {...props} />
      );
    case QuestionTypeEnum.FILL_IN_THE_BLANK:
      return (
        <FillInTheBlankFormService
          question={question as FillInTheBlankQuestion}
          {...props}
        />
      );
    case QuestionTypeEnum.FLASHCARD:
      return (
        <FlashcardFormService
          question={question as FlashcardQuestion}
          {...props}
        />
      );

    default:
      return (
        <QuestionPlaceholder type={question.type} className="min-h-[300px]" />
      );
  }
}
